import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-cms-login-image grow lg:ml-4" }
const _hoisted_2 = ["srcset"]
const _hoisted_3 = ["srcset"]
const _hoisted_4 = ["srcset"]
const _hoisted_5 = ["src", "alt"]

import { store } from "@/state/store";

export default /*@__PURE__*/_defineComponent({
  __name: 'ImageLandingPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("picture", null, [
      _createElementVNode("source", {
        srcset: _unref(store).landingPage.desktopImageURL,
        media: "(min-width: 1024px)"
      }, null, 8, _hoisted_2),
      _createElementVNode("source", {
        srcset: _unref(store).landingPage.tabletImageURL,
        media: "(min-width: 501px) and (max-width: 1023px)"
      }, null, 8, _hoisted_3),
      _createElementVNode("source", {
        srcset: _unref(store).landingPage.mobileImageURL,
        media: "(max-width: 500px)"
      }, null, 8, _hoisted_4),
      _createElementVNode("img", {
        class: _normalizeClass([[
					{ 'lg:h-[600px]': _unref(store).landingPage.hasHiResImage },
					{ 'lg:min-h-full': !_unref(store).landingPage.hasHiResImage },
				], "w-full lg:object-cover"]),
        src: _unref(store).landingPage.desktopImageURL,
        alt: _unref(store).landingPage.imageAltText,
        loading: "lazy"
      }, null, 10, _hoisted_5)
    ])
  ]))
}
}

})